import { configureStore } from '@reduxjs/toolkit';

import { appStateSlice } from './appState/appState';
import { careerPathSlice } from './careerPath/careerPath';
import { collegeSlice } from './college/college';
import { contentCategorySlice } from './contentCategory/contentCategory';
import { contentCompetencySlice } from './contentCompetency/contentCompetency';
import { contentNuggetSlice } from './contentNugget/contentNugget';
import { dataDictionarySlice } from './dataDictionary/dataDictionary';
import { lifeReadinessApi } from './lifeReadiness/lifeReadiness.api';
import { sessionStateReducer } from './lubavSessionState/lubavSessionState';
import { onboardingApi } from './onboarding/onboarding.api';
import { searchSlice } from './search/search';
import { surveyStateSlice } from './survey/survey';
import { tourSlice } from './tour/tour';
import { userSlice } from './user/user';
import { userApi } from './user/user.api';
import { userResponseSetSlice } from './userResponse/userResponse';

export const store = configureStore({
  reducer: {
    user: userSlice.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [onboardingApi.reducerPath]: onboardingApi.reducer,
    [lifeReadinessApi.reducerPath]: lifeReadinessApi.reducer,

    // COLLEGE
    college: collegeSlice.reducer,

    // BLUEPRINT
    userResponseSet: userResponseSetSlice.reducer,
    survey: surveyStateSlice.reducer,
    careerPath: careerPathSlice.reducer,
    dataDictionary: dataDictionarySlice.reducer,
    tour: tourSlice.reducer,

    // PROSPER
    contentCategory: contentCategorySlice.reducer,
    contentCompetency: contentCompetencySlice.reducer,
    contentNugget: contentNuggetSlice.reducer,
    search: searchSlice.reducer,

    // LUBAV SESSIONS
    sessionState: sessionStateReducer,

    // APP STATE
    appState: appStateSlice.reducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      userApi.middleware,
      onboardingApi.middleware,
      lifeReadinessApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
